class MyLoansRequestCadastralController {
  constructor($window) {
    'ngInject';
    this.isMobileApp = $window.innerWidth < 1024;
    this.error = null;
    this.messageError = null;
  }

  $onInit() {
    this.STATE_SUCCESS = 'approve';
  }

  isApproved() {
    return this.error === this.STATE_SUCCESS;
  }

  isFailed() {
    return this.error !== null &&
           this.error !== undefined &&
           this.error !== '' &&
           this.error !== this.STATE_SUCCESS;
  }
}

export default MyLoansRequestCadastralController;


// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansRequestCadastral/myLoansRequestCadastral.controller.js